import auth from "./auth";
import media from "./media";
import modals from "./modals";
import megaphones from "./megaphones";
import companyValuesReducer from "../../company_values/reducers";
import projectSupportsReducer from "../../project_supports/reducers";
import projectBookmarksReducer from "../../project_bookmarks/reducers";

const reducers = {
  auth,
  media,
  modals,
  megaphones,
  company_values: companyValuesReducer,
  project_supports: projectSupportsReducer,
  project_bookmarks: projectBookmarksReducer,
};

export default reducers;



// WEBPACK FOOTER //
// ./frontend/src/common/reducers/index.ts